import type { ReactNode } from 'react';
import { ControlCenterContext } from './useControlCenter';
import { useControlCenterPage } from './useControlCenterPage';
import { ControlCenterOverlays } from './ControlCenterOverlays';

type ControlCenterProviderProps = {
    children: ReactNode;
};

export const ControlCenterProvider = ({
    children,
}: ControlCenterProviderProps) => {
    const state = useControlCenterPage();

    return (
        <ControlCenterContext.Provider value={state}>
            {children}
            <ControlCenterOverlays />
        </ControlCenterContext.Provider>
    );
};
